import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

// Thunk for getting all CARTS
export const getNotifications = createAsyncThunk(
    'get-notification',
    async (_, { rejectWithValue }) => {
        try {

            const response = await GET(APIS.GET_NOTIFICATIONS);
            return response;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for Checking itme in  CART
export const getSingleNotification = createAsyncThunk(
    'get-single-notification',
    async (id, { rejectWithValue }) => {
        try {
            const response = await GET(APIS.GET_NOTIFICATIONS + `/${id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const updateNotificationStatus = createAsyncThunk(
    "update-status",
    async (id, { rejectWithValue }) => {
        try {
            const response = await POST(APIS.GET_NOTIFICATIONS + `/${id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }

);


export const getNotificationSetting = createAsyncThunk(
    'get-notification-s',
    async (_, { rejectWithValue }) => {
        try {

            const response = await GET(`${APIS.GET_NOTIFICATIONS}/settings`);
            return response;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateNotificationSetting = createAsyncThunk(
    "update-setting",
    async (data, { rejectWithValue }) => {
        try {
            const response = await PUT(APIS.GET_NOTIFICATIONS + `/settings`, data);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }

);


// Create the slice
const Slice = createSlice({
    name: "notification",
    initialState: {
        data: [],
        setting: [],
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationSetting.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getNotificationSetting.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.setting = action.payload?.data || [];

            })
            .addCase(getNotificationSetting.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;

            })
            .addCase(getNotifications.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload?.data || [];

            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;

            })

            .addCase(getSingleNotification.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getSingleNotification.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload?.data;

            })
            .addCase(getSingleNotification.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
    },
});

export default Slice.reducer;




